import { render, staticRenderFns } from "./PersonalProfileForm.vue?vue&type=template&id=1e0bc8ef&"
import script from "./PersonalProfileForm.vue?vue&type=script&lang=js&"
export * from "./PersonalProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports